import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model"
import { TrainersModel } from "../Trainers Model/trainers-data.model"

export class ViewTrainersGridModel extends TrainersModel { }

export class ViewTrainersListingModel extends GridModel<ViewTrainersGridModel> { }

export class ViewTrainersGridParams extends GridPostParams {
  pageNumber:any= 1
  pageSize:any= 10
  search_key:any='' 
  trainer_id:any= 3086
  direction:any='' 
  column:any='' 
}